import { useEffect, useState } from "react";
import { api, type CatalogItem } from "../api";

export function useCatalog() {
  const [items, setItems] = useState<CatalogItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = () => {
    setLoading(true);
    setError("");
    api.catalog()
      .then(setItems)
      .catch((reason) => setError(reason instanceof Error ? reason.message : "No pudimos abrir el catálogo."))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);
  return { items, loading, error, reload: load };
}
